import { Box } from "theme-ui";

export default function RotateLeftIcon(props) {
  return (
    <Box
      as="svg"
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25.6667 54.408L25.6667 58.5225C16.4662 54.8127 10.8908 52.0059 2.30742 47.0389C11.9441 43.308 17.677 40.564 25.6667 35.5292L25.6667 39.8007V41.0042L26.8498 40.7838C41.4457 38.0643 53.3147 31.0005 58.3746 21.7399C58.7865 23.2589 59 24.8165 59 26.4032C59 32.6397 55.691 38.4832 49.9248 43.2509C44.1578 48.0193 35.9913 51.6534 26.4835 53.4249L25.6667 53.5771V54.408ZM56.3893 18.1194L56.3892 18.1194C55.5594 20.1377 54.3298 22.0995 52.73 23.9616C48.0816 19.6471 41.732 16.1627 34.3333 13.866L34.3333 1.35623C44.8722 4.74748 52.9029 10.5689 56.6524 17.4793L56.3893 18.1194Z"
        fill="black"
        stroke="white"
        strokeWidth="2"
      />
    </Box>
  );
}
